import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { workareaBaseQuery } from './workArearBaseQuery';
import { CodelistResponce } from 'src/types/URLKeys';

export const codeList = createApi({
  baseQuery: workareaBaseQuery,
  reducerPath: 'codeList',
  endpoints: builder => ({
    getCodeListData: builder.query<any, any>({
      query: code_list_code => ({
        url: formatString(endPoints.CodeList.getAll, {
          key: urlKeys.code_list_code,
          value: code_list_code
        }),
        method: 'POST',
        extraOptions: { maxRetries: 3 }
      }),
      transformResponse: (response: CodelistResponce) => response?.selected_data ?? []
    }),
    getAllcodelistData: builder.query<any, void>({
      query: () => ({
        url: formatString(endPoints.CodeList.getAllCodeList),
        method: 'POST',
        body: ['GET_ALL_CODELIST_VALUE_CODES'],
        extraOptions: { maxRetries: 3 }
      })
    }),
    getIpTreatments: builder.query<any, any>({
      query: ({ study_id }) => ({
        url: formatString(endPoints.IPSupplyDetails.getAll, {
          key: 'study_id',
          value: study_id
        }),
        method: 'GET'
      })
    })
  })
});

export const { useGetCodeListDataQuery, useGetAllcodelistDataQuery, useGetIpTreatmentsQuery } = codeList;
